// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ImageComparison from './data'

export default function ImageComparisonFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ImageComparison">
      <ImageComparison {...props}>
        {children}
      </ImageComparison>
    </Flow>
  )
}
